// Mentions legales affichees dans les vues Bon de commande.
//
// Definies ICI et non recopiees dans chaque vue : le texte contractuel du Descriptif Technique existe
// en 18 exemplaires dans le projet, et une faute d'accord y a survecu jusqu'a devoir etre corrigee
// dans 13 fichiers d'un coup. Un texte juridique n'a qu'une seule redaction valable — il n'a donc
// qu'un seul endroit ou vivre.
//
// Cite des references reglementaires : toute modification doit etre validee cote metier, pas
// reformulee au fil d'une refonte d'interface.

/**
 * Portee de la duree de validite de l'accord-cadre sur les bons de commande.
 * Affichee dans la section « Descriptif procédural », a cote de la date de validite de l'accord-cadre
 * — c'est cette date que la mention vient qualifier.
 * Source : Code de la commande publique, articles R. 2162-2 et R. 2162-14.
 */
export const MENTION_VALIDITE_ACCORD_CADRE_BC =
  "En vertu des articles R. 2162-2 et R. 2162-14 du Code de la commande publique, l'accord-cadre à " +
  "bons de commande s'exécute au fur et à mesure de l'émission des bons. La durée de validité de " +
  "l'accord-cadre encadre seulement la notification des bons de commande, et non leur achèvement " +
  "matériel : un bon notifié avant le terme de l'accord-cadre demeure donc pleinement valable et " +
  'peut être exécuté après son expiration.';
